import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ControlledTable from "../../../component/ControlledTable";
import { useDispatch, useSelector } from "react-redux";
import { cloudRepListTable as tableDef } from "../../../config/grid-columns-defs";
import { handleAxiosError } from "../../../config/action-config";
import { Controller, useForm } from "react-hook-form";
import { showAlert } from "../../../actions/alert";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import { createCloudRep, getCloudRepList } from "../../../api/cloudRep";
import { CountryCodes } from "../../../countryCodes";
import BetterControlledTable from "../../../component/BetterControlledTable";
const useStyles = makeStyles((theme) => ({
  textfeild: {
    "& .MuiFilledInput-root": {
      color: "#fff !important",
    },
  },
}));

export default function CloudRepList() {
  const classes = useStyles();
  let obj = tableDef.find((o) => o.headerName === "Action");
  const user = useSelector((state) => state.user);
  const dialogAction = useSelector((state) => state.dialog);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [totalCount, setTotalCount] = useState(0);
  const [rows, setRows] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [company, setCompany] = useState("");
  const [industry, setIndustry] = useState("");
  const [companyListData, setCompanyListData] = useState([]);
  const [industryListData, setIndustryListData] = useState([]);
  const [stageListData, setStageListData] = useState([]);
  const [stage, setStage] = useState("");
  const [priority, setPriority] = useState("");
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [nameFilter, setNameFilter] = useState("");

  addAdditionalColumn(obj, dispatch);
  useEffect(() => {
    if (!dialogAction.type) return;
    switch (dialogAction.type) {
      case "VIEWCLOUDREP":
        dispatch({ type: "" });
        console.log("wwwww");
        navigate(`/cloudRep/${dialogAction.data.id}`);
        break;
      default:
        break;
    }
  }, [dialogAction]);

  useEffect(() => {
    refreshTable();
  }, [nameFilter]);
  //}, [company, industry, priority, stage]);
  // const getRows = async (numRows, startRow) => {
  //   return getCloudRepList(
  //     {
  //       name: nameFilter,
  //       //industry: "",
  //       //priority: "",
  //       //stage: "",
  //       limit: numRows,
  //       offset: startRow,
  //     },
  //     user.token
  //   )
  //     .then((res) => {
  //       setTotalCount(
  //         parseInt(res.data.data.total) === 0 ? -1 : res.data.data.total
  //       );
  //       return res.data.data.CloudRep;
  //     })
  //     .catch((err) => {
  //       handleAxiosError(err, dispatch);
  //       return [];
  //     });
  // };
  const [RefreshCount, setRefreshCount] = useState(0);
  async function getRows(limit, offset) {
    try {
      const { data } = await getCloudRepList(
        { limit, offset, name: nameFilter },
        user.token
      );

      return {
        rows: data.data.CloudRep,
        total: data.data.total,
        error: false,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }
  function refreshTable(e) {
    e?.preventDefault();
    setRefreshCount((prev) => prev + 1);
  }
  return (
    <Box
      className="pmt-container-box "
      sx={{
        borderTop: "1px solid #cecdcd",
      }}
    >
      <Box
        sx={{
          display: "flex",
          columnGap: 1,
          p: 1,
          borderBottom: 1,
          justifyContent: "flex-end",
        }}
      >
        <Grid item xs={12} sm={6} md={2} lg={3}>
          <TextField
            name="name"
            size="small"
            fullWidth
            label="Name"
            type="text"
            variant="outlined"
            value={nameFilter}
            onChange={(e) => {
              setNameFilter(e.target.value);
            }}
            className="name-textfeild rounded-textfeild"
          />
        </Grid>
        {/*<Box className="typography-title">
          <Typography>Cloud Rep</Typography>
        </Box>*/}

        <Button
          variant="contained"
          style={{ padding: "5px 7px", fontSize: "12px", fontWeight: "300" }}
          onClick={() => {
            setCreateDialogOpen(true);
          }}
          className="add-button"
        >
          Add New Contact
        </Button>
      </Box>

      {/* <br /> */}
      <div className="react-table">
        <BetterControlledTable
          hasActionButtons={false}
          getTableRows={getRows}
          columns={tableDef}
          perPage={25}
          refreshCounter={RefreshCount}
        />
      </div>
      {/* <div className="pmt-controll-table">
        <ControlledTable
          rows={rows}
          columnDefs={tableDef}
          getRows={getRows}
          totalCount={totalCount}
          onChange={setRows}
          onPageNumberChange={setPageNumber}
          pageSize={10}
          pageNumber={pageNumber}
          pagination={true}
          hasActionButtons={false}
        />
      </div> */}
      <AddNewLeadDialog
        open={createDialogOpen}
        setOpen={setCreateDialogOpen}
        onRefresh={refreshTable}
      />
    </Box>
  );
}

function addAdditionalColumn(obj, dispatch) {
  if (obj === undefined) {
    tableDef.unshift({
      headerName: "Action",
      field: "actions",
      resizable: true,
      wrapText: true,
      autoHeight: true,
      cellStyle: { fontSize: "11px" },
      minWidth: 65,
      headerClass: "justify-center",
      cellClass: "justify-center",
      cellRendererFramework: (params) => (
        <IconButton
          color="info"
          onClick={() => {
            dispatch({ type: "VIEWCLOUDREP", data: params.data });
          }}
        >
          <VisibilityIcon fontSize="inherit" />
        </IconButton>
      ),
    });
  }
}

const emptyNewLeadData = {
  name: "",
  email: "",
  contact: "",
  linkedin_url: "",
  address: "",
  // designation: "",
  country_code: "",
  state: "",
  city: "",
};
function AddNewLeadDialog({ open, setOpen, onRefresh }) {
  const user = useSelector((state) => state.user);
  const [data, setData] = useState(emptyNewLeadData);
  const [stageListData, setStageListData] = useState([]);
  const [IndustryListData, setIndustryListData] = useState([]);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({ defaultValues: emptyNewLeadData });

  const dispatch = useDispatch();
  useEffect(() => {
    if (open) {
      setData(emptyNewLeadData);
    }
  }, [open]);

  async function onNewLeadSubmit(newdata) {
    try {
      const { data } = await createCloudRep(newdata, user.token);
      setOpen(false);
      onRefresh();
      dispatch(showAlert(data.msg));
    } catch (err) {
      handleAxiosError(err, dispatch);
      setOpen(false);
    }
  }

  return (
    <Dialog
      open={open}
      onClose={() => {
        //setOpen(false);
      }}
    >
      <DialogTitle>Create New Contact</DialogTitle>
      <Box component="form" onSubmit={handleSubmit(onNewLeadSubmit)}>
        <DialogContent>
          <Grid
            container
            spacing={2}
            //  sx={{ pt: "1rem" }}
          >
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="name"
                fullWidth
                label="Name"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: false,
                  // required: "Name is required.",
                })}
                // required
                error={Boolean(errors.name)}
                helperText={errors.name?.message}
                className="name-textfeild"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="email"
                fullWidth
                label="Email"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: "Email address is required",
                  pattern: {
                    value:
                      /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                    message: "Please enter a valid e-mail address.",
                  },
                })}
                required
                error={Boolean(errors.email)}
                helperText={errors.email?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <FormControl
                fullWidth
                // required
                error={Boolean(errors.country_code)}
              >
                <InputLabel id="demo-simple-select-label">
                  Country Code
                </InputLabel>
                <Controller
                  render={(props) => (
                    <Select
                      MenuProps={{ className: "select-box-height" }}
                      value={props.value}
                      label="Country Code"
                      onChange={props.onChange}
                    >
                      {CountryCodes.map((data, key) => (
                        <MenuItem key={key} value={data.code}>
                          +{data.code} {data.country}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  name="country_code"
                  control={control}
                  // defaultValue=""
                  rules={{
                    required: false,
                    // required: "Please select Country Code",
                  }}
                />
                <FormHelperText>{errors.country_code?.message}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={6}>
              <TextField
                name="contact"
                fullWidth
                label="Phone Number"
                variant="outlined"
                type="tel"
                inputProps={{ maxLength: 10 }}
                inputRef={register({
                  required: false,
                  //required: "Contact is required.",
                  // validate: (value) =>
                  //   value.length > 9 || "Please enter a valid contact number",
                })}
                // required
                error={Boolean(errors.contact)}
                helperText={errors.contact?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <TextField
                name="linkedin_url"
                fullWidth
                label="LinkedIn URL"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: false,
                  //required: "LinkedIn URL is required.",
                  pattern: {
                    value:
                      /^(http(s)?:\/\/)?([\w]+\.)?linkedin\.com\/(pub|in|profile)/,
                    message: "Please enter a valid linkedin url.",
                  },
                })}
                // required
                error={Boolean(errors.linkedin_url)}
                helperText={errors.linkedin_url?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="state"
                fullWidth
                label="State"
                type="text"
                // required
                inputRef={register({
                  required: false,
                  // required: "State is required.",
                })}
                error={Boolean(errors.state)}
                helperText={errors.state?.message}
                className="name-textfeild"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="city"
                fullWidth
                label="City"
                variant="outlined"
                type="text"
                inputRef={register({
                  required: false,
                  // required: "City is required.",
                })}
                // required
                error={Boolean(errors.city)}
                helperText={errors.city?.message}
                className="name-textfeild"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="address"
                fullWidth
                label="Address"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: false,
                  //required: "Address is required.",
                })}
                error={Boolean(errors.address)}
                helperText={errors.address?.message}
              />
            </Grid>
            {/* <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                name="designation"
                fullWidth
                label="Designation"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: false,
                  //required: "Designation is required.",
                })}
                error={Boolean(errors.designation)}
                helperText={errors.designation?.message}
              />
            </Grid> */}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpen(false);
            }}
            className="cancel-button"
          >
            Cancel
          </Button>
          <Button
            disabled={/^Trial_User$/i.test(user.role) ? true : false}
            // onClick={handleSubmit(onNewLeadSubmit)}
            type="submit"
            className="blue-button"
          >
            Submit
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
